import React, { Component } from 'react';
import './UserAddress.css';
import "../../CommonStyles/CSS.css";
//import dvas from '../../images/public/registeration/dvas.png';
//import clos from '../../images/public/registeration/clos.png';
//import back from '../../images/public/registeration/back.png';
import help from '../../images/public/userarea/tab5u.png';
//import crdscia from '../../images/public/userarea/crdscia.png';
//import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { isBrowser } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr';
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
import { getCounties } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
//import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import TopBar from '../../assets/components/topbar/TopBar';
import miniArrow from '../../images/public/registeration/miniarrow.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';


// const stageName = "Address";

const cookies = new Cookies();

class UserAddress extends Component {
	constructor(props) {
		super(props);

		let params = null;
		//console.log('[UserAddress]', params);

		this.state = {
			step: '3',
			isLoading: false,
			errmsg: null,
			errorFlg: false,
			workFlowInProgress: false, //used by workflow.js services to ensure data avaiability before next screen
			screenData: null,
			userOptions: [],
			canProceed: false,
			helpShow: false,
			helpMessage: "",
			province:"",
			province_id:"",
		};
	}

	componentDidMount() {
		// this.wf = new MPWorkFlow();
		// this.init();
		this.refresh();
		this.getCountryStates();
	}

	// async init() {
	//     // update screenData for current states
	//     await getWorkFlow(this, stageName);
	//     this.update();
	// }

	async update() {
		// updating server state...
		let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
		//console.log('[UserAddress] @update #resp', resp);
		if (!resp) return;
		if (resp.status === "success") {
			// updating localStorage
			MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
			await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Address"));
			// calling transit if link_next is available
			this.transit(this.state.screenData.link_next);

		} /* else if (resp.status === "fail") {
			this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });
		} */
	}

	async refresh() {
		// update screenData for current states
		await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Address"));
		//console.log('[UserAddress] @transit #MPWorkFlow.getInstance().getStageName("Address")', MPWorkFlow.getInstance().getStageName("Address"));
		this.setDefaultprovince();
		this.getUserAddressParams();
		// this.setState({ canProceed: this.state.screenData.link_next != "" });
	}

	// async transit(toWhere) {
	// 	//console.log('[UserAddress] @transit #toWhere', toWhere);
  //   console.log('before workflowTransition 7');
	// 	let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
	// 	//console.log('[UserAddress] @transit #resp', resp);

	// 	if (resp.status === "success") {
	// 		// updating localStorage and navigating to the new screen
	// 		MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
	// 		let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
	// 		// console.log("[UserAddress] @gotoResorts #getRouteName:", nextScreen);
	// 		return this.props.history.push(nextScreen);
	// 	} /*else if (resp.status === "fail") {
	// 			this.setState({ errorFlg: true, errmsg: resp.message });
	// 	}*/
	// }

  convertToISO88591(payloadString) {
    const iso88591Payload = payloadString.replace(/[^\x00-\xFF]/g, (char) => {
      return `&#${char.charCodeAt(0)};`;
    });
    return iso88591Payload;
  }

  preparePostData = (payload) => {
    const payloadString = Object.keys(payload)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
      .join('&');
    const iso88591Payload = this.convertToISO88591(payloadString);

    return iso88591Payload;
  };

  async transit(toWhere) {
    localStorage.setItem('isNexi', true);
    let price_info = {
      info: this.state.screenData.totals,
      priceToPay: this.state.screenData.total_amount
    }
    localStorage.setItem("price_info", JSON.stringify(price_info));
    let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });

    if (!resp || !resp.pay_response) return;
    if (resp.status === "success") {
      if (resp.pay_response.status === 'fail_credit_card' && resp.pay_response.method === 'POST') {
        const postUrl = resp.pay_response.paymentUrl;
        const postData = this.preparePostData(resp.pay_response.post_data);

        const iframe = document.createElement('iframe');
        console.log("window widht",window.innerWidth);
        if (window.innerWidth <= 480) {
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.top = '50%';
          // iframe.style.left = '50%';
          // iframe.style.transform = 'translate(-50%, -50%)';
          iframe.style.borderRadius = '0';
          iframe.style.margin = '0';
          iframe.style.padding = '0';
        } else {
          iframe.style.width = '60%';
          iframe.style.height = '80%';
          iframe.style.position = 'fixed';
          iframe.style.top = '60%';
          iframe.style.left = '50%';
          iframe.style.transform = 'translate(-50%, -50%)';
          iframe.style.borderRadius = '20px';
          iframe.style.zIndex = '9999';
          iframe.style.border = 'none';
        }

        document.body.appendChild(iframe);

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = postUrl;
        form.target = iframe.name;

        const formData = new URLSearchParams(postData);

        formData.forEach((value, key) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        iframe.contentWindow.document.body.appendChild(form);
        window.addEventListener('message', (event) => {
          try {
            const data = JSON.parse(event.data);
            console.log('Received message from iframe:', data);
            localStorage.setItem('nexiPaymentStatus', data.status);
            let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
            console.log("[Cart] @transit #getRouteName:", nextScreen);
            MPWorkFlow.getInstance().updateWorkflow(this, resp.data);

            setTimeout(() => {
              this.props.history.push('/transaction-confirm');
              iframe.remove();
            }, 10000);
          } catch (e) {
            console.error('Error parsing message from iframe:', e);
          }
        });

        this.setState({ workFlowInProgress: true });
        form.submit();
        setTimeout(() => {
          this.setState({ hidePay: true }, () => {
            this.setState({ iframe: iframe, showIframe: true, workFlowInProgress: false });
          });
        }, 5000);
        
      } else {
        localStorage.setItem('isNexi', false);
        // updating localStorage and navigating to the new screen
        MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
        let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
        console.log("[Cart] @transit #getRouteName:", nextScreen);
        if (this.state.screenData.link_next === 'Pay') {
          if (typeof window._fbq === 'function') {
            window._fbq('track', 'InitiateCheckout', {
              currency: 'EUR',
              value: this.state.screenData.total_amount
            });
          }
        }
        // console.log("[WelcomeScreen] @gotoResorts #getRouteName:", nextScreen);
        return this.props.history.push(nextScreen);
      }
    }
  }

		alertResponse(info) {
			switch (info.type) {
				case "closeButton":
					this.setState({ errorFlg: false })
					break;
				case "actionButton":
					if (info.option1 === "attention") {
						this.setState({ errorFlg: false })
					break;
					}
			}	
		}

		/* new functions for new flow */

		getUserAddressParams = () => {
			try {
				let address2, city, country, name, pcode, province, province_id, street, street_nr, surname;
				name = document.getElementById("user-address-name").value;
				surname = document.getElementById("user-address-surname").value;
				street = document.getElementById("user-address-street").value;
				street_nr = document.getElementById("user-address-street_nr").value;
				address2 = document.getElementById("user-address-address2").value;
				city = document.getElementById("user-address-city").value;
				pcode = document.getElementById("user-address-pcode").value;
				if(this.state.screenData) {
					province = this.state.screenData.province;
					province_id = this.state.screenData.province_id;
				}
				this.setState({
					name,
					surname,
					street,
					street_nr,
					address2,
					city,
					pcode,
					province,
					province_id,
				});

				// console.log(
				//     name,
				//     surname,
				//     street,
				//     street_nr,
				//     address2,
				//     city,
				//     pcode ,
				// );
				} catch (error) {
						
				}

		}

		missingInfo() {
			const {
				name,
				surname,
				street,
				street_nr,
				address2, // not mandatory fild
				city,
				pcode,
				province_id,
			} = this.state;

			return !name ||
				!surname ||
				!street ||
				!street_nr ||
				!city ||
				!pcode||
				!province_id;
		}


		helpShowModal = (help_tag) => {
			MPWorkFlow.getInstance().workflowHelp(this, {tag: help_tag});
		}

		onBack = () => {
				//       return this.props.history.push('/');
			this.transit(this.state.screenData.link_back);
		}

		gotoNextStage = (e) => {
			e.preventDefault();
			// this.transit(this.state.screenData.link_next);
			// despite rest of app we need to call update here to get the link_next
			// updating screenData
      console.log("address screen data", this.state.screenData);
			let screenData = this.state.screenData;
			screenData.address2= this.state.address2
			screenData.city= this.state.city
			screenData.name= this.state.name
			screenData.pcode= this.state.pcode
			screenData.province= this.state.province
			screenData.province_id= this.state.province_id
			screenData.street= this.state.street
			screenData.street_nr= this.state.street_nr
			screenData.surname= this.state.surname
			this.update();
		}

		//this call is used to get list of states in the needed format
		getCountryStates = () => {
			this.setState({ isLoading: true });
			let access_token = cookies.get('access_token');
			let params = {};
			getCounties(this, access_token, params).then((response) => {
				// console.log("[Indirizione] getCounties @response: ", response);
				if (response.length > 0) {
				// {provincia: "Agrigento", id_provincia: 97, sigla_provincia: "(AG)", regione: "Sicilia"}
				response.map(o => {
						o.provincia = o.provincia;
					
						Object.defineProperty(o, "label", Object.getOwnPropertyDescriptor(o, "provincia"));
						delete o["provincia"];
						Object.defineProperty(o, "value", Object.getOwnPropertyDescriptor(o, "id_provincia"));
						delete o["id_provincia"];
					});
					// console.log("[Indirizione] getCounties @response: after ", response);
					this.setState({ statesList: response });
				}
			});
		}

		setDefaultprovince() {
			if (this.state.screenData.province_id)
				this.setState({ province: this.state.screenData.province , province_id: this.state.screenData.province_id });
		}

		Address = () => {
			return <div>
				<div className="row">
					<div className="col-12 col-md-6 mb-35 mb-sm-50">
						<input
							disabled={ true }
							onChange={ this.getUserAddressParams }
							id="user-address-name"
							spellCheck={ false }
							className="sn_input cur-not-alloed"
							placeholder={ this.state.screenData.name_pholder }
							defaultValue={ this.state.screenData.name }
						/>
					</div>
					<div className="col-12 col-md-6 mb-35 mb-sm-50">
						<input
							disabled={true}
							onChange={this.getUserAddressParams}
							id="user-address-surname"
							spellCheck={false}
							className="sn_input cur-not-alloed"
							placeholder={this.state.screenData.surname_pholder}
							defaultValue={this.state.screenData.surname}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-12 col-md-6 mb-35 mb-sm-50">
						<input
							onChange={this.getUserAddressParams}
							id="user-address-street"
							spellCheck={false}
							className="sn_input"
							placeholder={this.state.screenData.street_pholder}
							defaultValue={this.state.screenData.street}
						/>
					</div>
					<div className="col-12 col-md-6 mb-35 mb-sm-50">
						<input
							onChange={this.getUserAddressParams}
							id="user-address-street_nr"
							spellCheck={false}
							className="sn_input"
							placeholder={this.state.screenData.street_nr_pholder}
							defaultValue={this.state.screenData.street_nr}
						/>
						</div>
					</div>
					<div className="row">
						<div className="col-12 mb-35 mb-sm-50">
							<input
								onChange={this.getUserAddressParams}
								id="user-address-address2"
								spellCheck={false}
								className="sn_input"
								placeholder={this.state.screenData.address2_pholder}
								defaultValue={this.state.screenData.address2}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12 col-md-6 mb-35 mb-sm-50">
							<input
								onChange={this.getUserAddressParams}
								id="user-address-city"
								spellCheck={false}
								className="sn_input"
								placeholder={this.state.screenData.city_pholder}
								defaultValue={this.state.screenData.city}
							/>
							</div>
							<div className="col-12 col-md-6 mb-35 mb-sm-50">
								<input
									onChange={this.getUserAddressParams}
									id="user-address-pcode"
									spellCheck={false}
									className="sn_input"
									placeholder={this.state.screenData.pcode_pholder}
									defaultValue={this.state.screenData.pcode}
								/>
						</div>
					</div>
					<div className="row mb-5">
						<div className="col-12 col-md-6 d-flex justify-content-center">
							<div className="w-100 t_dropdown">
								<Dropdown
									disabled={false}
									placeholder={this.state.screenData.provice_pholder}
									name="province"
									options={this.state.statesList}
									value={{ label: this.state.province, value: this.state.province_id }}
									arrowClassName={'myArrowClassName'}
									controlClassName={"user-address-dropdown"}
									onChange={(val) =>{console.log(val); this.setState({ province: val.label, province_id: val.value })}}
								/>
							</div>
						</div>
						<div className="col-12 col-md-6 d-flex justify-content-center">
							<div className="w-100">
							<Dropdown
								disabled={true}
								name="country"
								placeholder={this.state.screenData.country_pholder}
								value={{ label: this.state.screenData.country, value: this.state.screenData.country_id }}
								arrowClassName={'myArrowClassName'}
								controlClassName={"user-address-dropdown-country"}
								onChange={(val) => null}
							/>
							</div>
						</div>
					</div>
				</div>
				}
		AddressMobile = () => {
			return <div>
			<div className="row">
				<div className="col-12 col-md-6 mb-35 mb-sm-50">
					<input
						disabled={ true }
						onChange={ this.getUserAddressParams }
						id="user-address-name"
						spellCheck={ false }
						className="sn_input cur-not-alloed"
						placeholder={ this.state.screenData.name_pholder }
						defaultValue={ this.state.screenData.name }
					/>
				</div>
				<div className="col-12 col-md-6 mb-35 mb-sm-50">
					<input
						disabled={true}
						onChange={this.getUserAddressParams}
						id="user-address-surname"
						spellCheck={false}
						className="sn_input cur-not-alloed"
						placeholder={this.state.screenData.surname_pholder}
						defaultValue={this.state.screenData.surname}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-12 col-md-6 mb-35 mb-sm-50">
					<input
						onChange={this.getUserAddressParams}
						id="user-address-street"
						spellCheck={false}
						className="sn_input"
						placeholder={this.state.screenData.street_pholder}
						defaultValue={this.state.screenData.street}
					/>
				</div>
				<div className="col-12 col-md-6 mb-35 mb-sm-50">
					<input
						onChange={this.getUserAddressParams}
						id="user-address-street_nr"
						spellCheck={false}
						className="sn_input"
						placeholder={this.state.screenData.street_nr_pholder}
						defaultValue={this.state.screenData.street_nr}
					/>
					</div>
				</div>
				<div className="row">
					<div className="col-12 mb-35 mb-sm-50">
						<input
							onChange={this.getUserAddressParams}
							id="user-address-address2"
							spellCheck={false}
							className="sn_input"
							placeholder={this.state.screenData.address2_pholder}
							defaultValue={this.state.screenData.address2}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-12 col-md-6 mb-35 mb-sm-50">
						<input
							onChange={this.getUserAddressParams}
							id="user-address-city"
							spellCheck={false}
							className="sn_input"
							placeholder={this.state.screenData.city_pholder}
							defaultValue={this.state.screenData.city}
						/>
						</div>
						<div className="col-12 col-md-6 mb-35 mb-sm-50">
							<input
								onChange={this.getUserAddressParams}
								id="user-address-pcode"
								spellCheck={false}
								className="sn_input"
								placeholder={this.state.screenData.pcode_pholder}
								defaultValue={this.state.screenData.pcode}
							/>
					</div>
				</div>
				<div className="row mb-5">
					<div className="col-12 col-md-6 d-flex justify-content-center">
						<div className="w-100 t_dropdown">
							<Dropdown
								disabled={false}
								placeholder={this.state.screenData.provice_pholder}
								name="province"
								options={this.state.statesList}
								value={{ label: this.state.province, value: this.state.province_id }}
								arrowClassName={'myArrowClassName'}
								controlClassName={"user-address-dropdown"}
								onChange={(val) =>{console.log(val); this.setState({ province: val.label, province_id: val.value })}}
							/>
						</div>
					</div>
					<div className="col-12 col-md-6 d-flex justify-content-center">
						<div className="w-100">
						<Dropdown
							disabled={true}
							name="country"
							placeholder={this.state.screenData.country_pholder}
							value={{ label: this.state.screenData.country, value: this.state.screenData.country_id }}
							arrowClassName={'myArrowClassName'}
							controlClassName={"user-address-dropdown-country"}
							onChange={(val) => null}
						/>
						</div>
					</div>
				</div>
			</div>
			}
	render() {
		//console.log('[UserAddress]', this.state);
		return (
		<Router>
			{
				this.state.screenData &&
				<div>
					<div>
						<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
							<div className="row flex-nowrap">
								<div className="col-2 d-flex align-items-center">
									<button className="sn_btnbox" onClick={()=>this.onLogout()}><img className="sn_mobile_top_row_arrow" src={ miniArrow } alt=""/></button>
								</div>
								<div className="col-8 d-flex align-items-center justify-content-center">
									<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
								</div>
								<div className="col-2 d-flex align-items-center justify-content-end">
									<button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={ help } alt=""/></button>
								</div>
							</div>
						</div>
						<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
						<div className="sn_overlay d-lg-none"></div>
						<div className="sn_address">
							<div className="container">
								<div className="row">
									<div className="col-12 col-lg-9 mx-auto">
										<div className="sn_register__container p-3 p-md-4 p-lg-5 overflow-visible">
											<div className="row d-none d-lg-block">
												<div className="col-12 d-flex justify-content-end">
												{/*{
													this.state.screenData && this.state.screenData.link_back &&
													<div className="sn_back">
														<a onClick={this.onBack}>
															<img src={ miniArrow } alt=""/>
														</a>
													</div>
												}*/}
												{
													this.state.screenData && this.state.screenData.help_tag &&
													<div className="sn_quest">
														<a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
															<img src={ help } alt=""/>
														</a>
													</div>
												}
												</div>
											</div>
											<div className="row mb-5">
												<div className="col-12">
													<h3 className="text-center">{ HtmlWrapper(this.state.screenData.title) }</h3>
													<h5>{ HtmlWrapper(this.state.screenData.desc) }</h5>
												</div>
											</div>
											{ isBrowser? this.Address(): this.AddressMobile() }
											<div className="row">
												<div className="col-12 d-flex flex-column flex-column-reverse align-items-center flex-sm-row justify-content-end">
													<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={ this.onBack }>{ tr.t('back') }</button>
													<button disabled={ this.missingInfo() } className="sn_btn" onClick={ this.gotoNextStage }>
													{ this.state.screenData.purchase_button }
													</button>
												</div>
											</div>
											<div className="row d-lg-none mt-5">
												<div className="col-12">
													<ProgressBullets step={ this.state.step } />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{
							this.state.errorFlg ?
							<div className="containerModal">
							{
								this.state.errorFlg ?
								<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
							}
							</div> : null
						}
						</div>
				<WaitLoad enable={this.state.isLoading || this.state.workFlowInProgress} />
				{ this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
			</div>
			}
			</Router>
		);
	}
}

export default UserAddress;


// WEBPACK FOOTER //
// ./src/screens/UserAddress/UserAddress.js